import { useState } from "react";
import { Button } from "@shared/ui/button";
import { toast } from "@shared/hooks/use-toast";
import { ConsumerDetailsReview } from "./consumerInfo";
import { ServiceDetailsReview } from "./serviceDetail";
import { AddressInformationReview } from "./addressInfo";
import { UploadedDocumentsReview } from "./documentsInfo";
import { useNavigate, useParams } from "react-router-dom";

interface ApplicationReviewLandingProps {
  onNext?: () => void;
  onPrevious?: () => void;
  onGoToStep?: (step: number) => void;
  isFirstStep?: boolean;
  isLastStep?: boolean;
  data?: any;
  allStepData?: any;
  onDataChange?: (data: any) => void;
}

export function ApplicationReviewLanding({
  onNext,
  onPrevious,
  onGoToStep,
  isFirstStep,
  isLastStep,
  data,
  allStepData,
  onDataChange,
}: ApplicationReviewLandingProps) {
  const navigate = useNavigate();
  const { consumerId } = useParams();

  const localSavedRaw =
    typeof window !== "undefined"
      ? localStorage.getItem("consumerFirstStepData")
      : null;
  const localSavedData = localSavedRaw ? JSON.parse(localSavedRaw) : null;

  // ✅ FIXED – match the actual keys sent from ApplicationDetailLanding
  const consumerData = allStepData?.[0]?.consumer || localSavedData?.consumer;
  const serviceData = allStepData?.[0]?.service || localSavedData?.service;
  const documentData = allStepData?.[0]?.document || localSavedData?.document;

  const handleEditSection = (section: string) => {
    if (onGoToStep) {
      onGoToStep(0); // go back to first step
    } else if (onPrevious) {
      onPrevious();
    }
  };

  console.log("➡️ category from previous step:", data);

  const handleSubmit = () => {
    if (onNext) onNext();

    navigate(`/cx/consumer-management/manual/success/${consumerId}`, {
      state: {
        consumerData: consumerData,
      },
    });
  };

  const handleBack = () => {
    if (onPrevious) {
      onPrevious();
    } else if (onGoToStep) {
      onGoToStep(0);
    }
  };

  return (
    <div className="w-full space-y-6">
      {/* Consumer Details Review */}
      <ConsumerDetailsReview
        data={consumerData}
        onEdit={() => handleEditSection("Consumer Details")}
      />

      {/* Service Details Review */}
      <ServiceDetailsReview
        data={serviceData}
        onEdit={() => handleEditSection("Service Details")}
      />

      {/* Address Information Review */}
      <AddressInformationReview
        data={serviceData}
        onEdit={() => handleEditSection("Address Information")}
      />

      {/* Uploaded Documents Review */}
      <UploadedDocumentsReview
        data={documentData}
        onEdit={() => handleEditSection("Uploaded Documents")}
      />
      {/* Action Buttons */}
      <div className="flex justify-between pt-6 border-t border-gray-200">
        <Button variant="outline" onClick={handleBack}>
          Back
        </Button>

        <Button
          variant="default"
          className="bg-blue-600 hover:bg-blue-700"
          onClick={handleSubmit}
        >
          Submit Application
        </Button>
      </div>
    </div>
  );
}
